import { apiClient } from '@/shared/api/client';

export type HoldStatus =
    | 'PENDING'
    | 'HELD'
    | 'PENDING_DEPOSIT'
    | 'SW_ONLY'
    | 'PROCESSED'
    | 'FORCED';

export interface PromoSuppSettlementDto {
    seqNo: number;
    suppId: string;
    acctStDate: string;
    acctEdDate: string;
    totalPromoCost: number;
    partnerAcctVal: number | null;
    holdStatus: HoldStatus;
    noticeId: number | null;
    insDate: string | null;
    insUser: string;
    updDate: string | null;
    updUser: string | null;
}

const BASE_PATH = '/api/v1/promotion/supp-settlement';

export const promoSuppSettlementApi = {
    getList: async (
        acctStDate: string,
        acctEdDate: string
    ): Promise<PromoSuppSettlementDto[]> => {
        const response = await apiClient.get<PromoSuppSettlementDto[]>(BASE_PATH, {
            params: { acctStDate, acctEdDate },
        });
        return response.data;
    },

    forceProcess: async (
        suppId: string,
        acctStDate: string,
        acctEdDate: string,
        userId: string
    ): Promise<void> => {
        await apiClient.post(`${BASE_PATH}/${suppId}/force`, null, {
            params: { acctStDate, acctEdDate, userId },
        });
    },

    processSwOnly: async (
        suppId: string,
        acctStDate: string,
        acctEdDate: string,
        userId: string
    ): Promise<void> => {
        await apiClient.post(`${BASE_PATH}/${suppId}/sw-only`, null, {
            params: { acctStDate, acctEdDate, userId },
        });
    },
};
